/* eslint-disable unicorn/no-null */
import { CheckAvailabilityResponse, Subject } from 'services/api';
import { StateCreator } from 'zustand';

export type QuestionOption = {
  type: string;
  value: string;
};

export type Question = {
  id: string;
  media: string | null;
  type: string | null;
  text: string;
  options: QuestionOption[];
};

export type Answer = string[] | { id: string; text?: string; image?: string }[];

export interface TestState {
  selectedSubject: Subject | undefined;
  availabilityResponse: CheckAvailabilityResponse | null;
  taskEndTime: string | null;
  currentQuestion: Question | null;
  isSuccessfulSubmission: boolean | null;
  missionAttemptNo: number | null;
  setSelectedSubject: (subject: Subject | undefined) => void;
  setAvailabilityResponse: (response: CheckAvailabilityResponse | null) => void;
  setTaskEndTime: (time: string | null) => void;
  setCurrentQuestion: (question: Question | null) => void;
  setIsSuccessfulSubmission: (isSuccessful: boolean | null) => void;
  setMissionAttemptNo: (missionAttemptNo: number | null) => void;
  resetState: () => void;
  questionCount: number | undefined;
  setQuestionCount: (questionCount: number) => void;
  incrementQuestionCount: () => void;
}

export const createTestSlice: StateCreator<
  TestState,
  [['zustand/devtools', never]],
  [],
  TestState
> = (set) => ({
  // Initial state
  selectedSubject: undefined,
  availabilityResponse: null,
  attemptId: null,
  taskEndTime: null,
  currentQuestion: null,
  isSuccessfulSubmission: null,
  missionAttemptNo: null,
  questionCount: undefined,

  // Actions
  setSelectedSubject: (selectedSubject) =>
    set({ selectedSubject }, false, 'testSlice/setSelectedSubject'),

  setAvailabilityResponse: (availabilityResponse) =>
    set({ availabilityResponse }, false, 'testSlice/setAvailabilityResponse'),

  setTaskEndTime: (taskEndTime) => set({ taskEndTime }, false, 'testSlice/setTaskEndTime'),

  setCurrentQuestion: (currentQuestion) =>
    set({ currentQuestion }, false, 'testSlice/setCurrentQuestion'),

  setIsSuccessfulSubmission: (isSuccessfulSubmission) =>
    set({ isSuccessfulSubmission }, false, 'testSlice/setIsSuccessfulSubmission'),

  setMissionAttemptNo: (missionAttemptNo) =>
    set({ missionAttemptNo }, false, 'testSlice/setMissionAttemptNo'),

  resetState: () =>
    set(
      {
        selectedSubject: undefined,
        availabilityResponse: null,
        taskEndTime: null,
        currentQuestion: null,
        isSuccessfulSubmission: null,
      },
      false,
      'testSlice/resetState',
    ),

  setQuestionCount: (questionCount) => set({ questionCount }, false, 'testSlice/setQuestionCount'),
  incrementQuestionCount: () =>
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    set((state) => ({ questionCount: state.questionCount ? state.questionCount + 1 : 1 })),
});
